module.exports = __webpack_public_path__ + "img/small_sft.f9da019a.png";